module.exports = __webpack_public_path__ + "img/guest.df1a7bff.png";